<template>
  <component :is="layout">
    <slot></slot>
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { layouts } from './index'

// Get current route
const route = useRoute()

// Pick layout from route meta
const layout = computed(() => {
  const layoutName = route.meta.layout
  return layouts[layoutName]
})
</script>